import { render, staticRenderFns } from "./_importId.vue?vue&type=template&id=0e4f9a78&"
import script from "./_importId.vue?vue&type=script&lang=js&"
export * from "./_importId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports